import React from 'react';
import { ApproveDailyReportForm } from 'modules/components/layer12';
import { BasicFormModalLayout } from 'modules/components/layer13';


export type ApproveDailyReportModalProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};

export const FC = (props: ApproveDailyReportModalProps) => {

  return (
    <BasicFormModalLayout.FC
      id={props.id}
      title='Approve daily report'
      subTitle=''
      handleClose={props.handleClose}
      isVisible={props.isVisible}
    >
      <ApproveDailyReportForm.FC
        id={props.id}
        handleClose={props.handleClose}
      />
    </BasicFormModalLayout.FC>
  );

};
